import { ReactNode } from 'react';
import AdminSideBar from './AdminSideBar';

/**
 * The two-column shell every `/quan-ly` screen sits in.
 *
 * It was `flex gap-3` with a `w-[244px]` rail and no breakpoint. The parent is
 * `.container-base`, so on a 390px phone that arithmetic came to 102px of page:
 * every admin screen was rendering into a column narrower than one table
 * column, and `overflow-x-clip` on the master layout meant the rest was clipped
 * rather than scrollable -- gone, with no scrollbar to reach it.
 *
 * The columns stack below `lg`, where the rail becomes the disclosure in
 * `AdminSideBar`. `min-w-0` on the page column is the load-bearing half of the
 * fix: without it a wide table sets the flex item's minimum size and pushes the
 * rail off instead of scrolling inside its own container.
 */
const AdminManagementLayout = ({ children }: { children: ReactNode }) => {
    return (
        <div className="lg:flex lg:gap-3">
            <div className="lg:w-[244px] lg:shrink-0">
                <AdminSideBar />
            </div>
            <div className="flex-1 min-w-0 bg-white p-4">{children}</div>
        </div>
    );
};

export default AdminManagementLayout;
